import { api } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ACADEMY_CATEGORIES = ["Getting Started", "Content Management", "Advertising", "Finance", "Advanced"];

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export const fmtDuration = (sec) => {
  const s = Math.round(sec || 0);
  if (s < 60) return `${s} sec`;
  const m = Math.round(s / 60);
  return `${m} minute${m === 1 ? "" : "s"}`;
};

export const fmtClock = (sec) => {
  const s = Math.round(sec || 0);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};

export const readVideoDuration = (file) => new Promise((resolve) => {
  const v = document.createElement("video");
  v.preload = "metadata";
  v.onloadedmetadata = () => { URL.revokeObjectURL(v.src); resolve(Math.round(v.duration || 0)); };
  v.onerror = () => resolve(0);
  v.src = URL.createObjectURL(file);
});

export async function uploadVideo(file, onProgress, kind = "video") {
  const { data } = await api.post("/admin/academy/uploads", { filename: file.name, size: file.size, content_type: file.type || "video/mp4", kind });
  const { upload_id, chunk_size, parts } = data;
  for (let i = 0; i < parts; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    let tries = 0;
    for (;;) {
      try {
        await api.put(`/admin/academy/uploads/${upload_id}/chunks/${i}`, blob, { headers: { "Content-Type": "application/octet-stream" } });
        break;
      } catch (e) {
        if (++tries >= 3) throw e;
        await new Promise((r) => setTimeout(r, 1000 * tries));
      }
    }
    onProgress?.(Math.round(((i + 1) / parts) * 100));
  }
  const done = await api.post(`/admin/academy/uploads/${upload_id}/complete`);
  return done.data.video_url;
}
